// extracted by mini-css-extract-plugin
export var container = "_fe-0";
export var icon = "_fe-1";
export var text = "_fe-2";